<template>
  <input-form :printable="printable" :title="title" @save="save" @close="close" @print="print"
              :refreshable="refreshable" @refresh="refresh" v-if="loaded" :editable="editable">
    <v-container grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-select :items="employeeList" v-model="item.employee" label="Employee" autocomplete return-object
                    item-value="empId" item-text="displayName" :rules="rules.employee" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg4>
          <v-text-field v-model="jobClass" label="Employee Job Class" disabled readonly />
        </v-flex>
        <v-flex xs12 lg4>
          <v-text-field v-model="jobProfileName" label="Employee Job Profile" disabled readonly />
        </v-flex>
        <v-flex xs12 lg4>
          <v-text-field v-model="divisionDept" label="Employee Division/Department" disabled readonly />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="cities" v-model="item.fromCity.id" label="From City" autocomplete
                    item-value="id" item-text="value" :rules="rules.fromCity" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="cities" v-model="item.toCity.id" label="To City" autocomplete
                    item-value="id" item-text="value" :rules="rules.toCity" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <date-time-picker v-model="item.fromDate" label="From Date" :rules="rules.fromDate"
                            :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <date-time-picker v-model="item.toDate" label="To Date" :rules="rules.toDate"
                            :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="transportations" v-model="item.transportation.id" label="Transportation" autocomplete
                    item-value="id" item-text="name" :rules="rules.transportation" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="accomodations" v-model="item.accomodation.id" label="Accomodation" autocomplete
                    item-value="id" item-text="name" :rules="rules.accomodation" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <number-text-field label="Sub Total" v-model="subTotal" readonly disabled prefix="Rp." />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="costTypes" v-model="item.costType" label="Cost Type" autocomplete required
                    :rules="rules.costType" @input="change" :disabled="!editable" :readonly="!editable" />
        </v-flex>
        <v-flex xs12>
          <v-text-field v-model="item.purpose" label="Purpose" :rules="rules.purpose"
                        :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12>
          <v-text-field multi-line rows="2" v-model="item.remark" label="Remark" :rules="rules.remark"
                        :disabled="!editable" :readonly="!editable" />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="employeeList" v-model="item.assignorOne" label="Assignor One" autocomplete return-object
                    item-value="empId" item-text="displayName" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
        <v-flex xs12 lg6>
          <v-select :items="employeeList" v-model="item.assignorTwo" label="Assignor Two" autocomplete return-object
                    item-value="empId" item-text="displayName" @input="change"
                    :disabled="!editable" :readonly="!editable" required />
        </v-flex>
      </v-layout>
    </v-container>
  </input-form>
</template>

<script>
import Promise from 'promise-polyfill'
import DateTimePicker from '@/components/lookup/DateTimePicker'
import InputForm from '@/components/InputForm'
import NumberTextField from '@/components/lookup/NumberTextField'

import Vuex from 'vuex'

const employeeStore = Vuex.createNamespacedHelpers('Employee')
const genericStore = Vuex.createNamespacedHelpers('Generic')

export default {
  name: 'business-trip-request-employee-form',
  components: {
    DateTimePicker,
    InputForm,
    NumberTextField
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Business Trip Request Employee Form'
    },
    value: {
      type: Object,
      required: true
    },
    /* list of employee (empId) to exclude from the selection list */
    exclude: {
      type: Array,
      required: false,
      default: () => []
    },
    refreshable: {
      type: Boolean,
      required: false,
      default: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    printable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      formValid: false,
      loaded: false,
      item: this.value,
      rules: {
        employee: [
          v => typeof this.employees.find(x => x.empId === v.empId) !== 'undefined' || 'Invalid employee'
        ],
        fromCity: [
          v => !!v || 'Must specify from city.'
        ],
        toCity: [
          v => !!v || 'Must specify to city.'
        ],
        fromDate: [
          v => (this.item.toDate === null) || (this.item.fromDate <= this.item.toDate) || 'Invalid Date.'
        ],
        toDate: [
          v => (this.item.fromDate === null) || (this.item.fromDate <= this.item.toDate) || 'Invalid Date.'
        ],
        accomodations: [
          v => !v || 'Must specify accomodation.'
        ],
        purpose: [
          v => (typeof v !== 'undefined') || 'Must specify purpose.',
          v => (v.length >= 5 && v.length <= 500) || 'Min. 5 characters and Max. 500 characters'
        ],
        remark: [
          v => (typeof v === 'undefined' || v.length <= 500) || 'Remark max. 500 characters'
        ],
        costType: [
          v => !!v || 'Invalid Cost Type'
        ]
      }
    }
  },
  computed: {
    ...employeeStore.mapState({
      employees: 'items'
    }),
    ...genericStore.mapState({
      cities: 'cities',
      transportations: 'transportations',
      accomodations: 'accomodations',
      costTypes: 'costTypes'
    }),
    employeeList () {
      if (this.employees !== null) {
        return this.employees.filter(x => !this.exclude.includes(x.empId))
      } else {
        return []
      }
    },
    subTotal () {
      return this.item.expenses.map(x => x.subTotal).reduce((x, y) => x + y, 0)
    },
    jobClass () {
      return typeof this.item.employee.job !== 'undefined' ? this.item.employee.job.jobClass : 'Select employee first'
    },
    jobProfileName () {
      return typeof this.item.employee.job !== 'undefined' ? this.item.employee.job.jobProfileName : 'Select employee first'
    },
    divisionDept () {
      return typeof this.item.employee.job !== 'undefined' ? this.item.employee.job.divisionDept : 'Select employee first'
    }
  },
  methods: {
    ...employeeStore.mapActions({
      listEmployee: 'list'
    }),
    ...genericStore.mapActions({
      listCities: 'listCities',
      listTransportations: 'listTransportations',
      listAccomodations: 'listAccomodations',
      listCostTypes: 'listCostTypes'
    }),
    change () {
      this.$emit('input', this.item)
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', this.item)
    },
    print () {
      this.$emit('print', this.item)
    },
    loadResources () {
      const self = this
      const resources = [self.listEmployee({vueinstance: self}), self.listCities({vueinstance: self}),
        self.listTransportations({vueinstance: self}), self.listAccomodations({vueinstance: self}),
        self.listCostTypes({vueinstance: self})
      ]
      Promise.all(resources).then(res => {
        self.loaded = true
      }).catch(err => {
        self.$error(err)
      })
    },
    refresh () {
      this.$emit('refresh', this.item)
    }
  },
  mounted () {
    this.loadResources()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestEmployeeForm.vue